/**
 * External dependencies
 */
import React from 'react';
import page from 'page';

/**
 * Internal dependencies
 */
import MainComponent from './main';

export const index = (context, next) => {
    context.primary = <MainComponent  />;
    next();
};

